import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled, { css } from 'styled-components';

interface FreeBonusesContainerProps {
  backgroundColor?: string;
}

export const FreeBonusesContainer = styled.div<FreeBonusesContainerProps>`
  width: 100%;
  box-sizing: border-box;
  padding: 3rem 2rem;
  background: ${({ backgroundColor }) => backgroundColor || palette.accentBlue};
`;

export const TextBlock = styled.div`
  & > .text-block-header,
  & > .text-block-paragraph {
    margin-bottom: 0.5rem;
  }
`;

interface HubspotFormWrapperProps {
  showForm?: boolean;
}

export const FreeBonusesFormWrapper = styled.div<HubspotFormWrapperProps>`
  display: grid;
  column-gap: 1rem;
  margin: 2rem auto 0;
  max-width: 760px;
  grid-template-columns: 1fr 174px;

  @media all and (max-width: ${layout.md}) {
    grid-template-columns: 1fr;
    max-width: 500px;
  }

  ${({ showForm }) =>
    showForm
      ? css`
          opacity: 1;
          display: grid;
        `
      : css`
          display: none;
        `};
`;

export const FreeBonusesFormContainer = styled.div`
  form {
    input[type='submit'] {
      display: none; // we are going to use our own submit button
    }
  }

  // form styling
  form {
    color: ${palette.white};
    // error styling
    .hs-error-msgs {
      margin: 0.5rem 0 0.5rem 1rem;
      list-style-type: none;
      padding-left: 0;
      font-size: 0.825rem;
      color: ${palette.softErrorRed};
      text-align: center;
    }

    fieldset {
      // legal text is provided externally
      .legal-consent-container {
        display: none;
      }

      // styling input and label for form this specific form
      &.form-columns-2 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        max-width: 100%;
        column-gap: 1rem;

        div.hs-form-field {
          width: 100%;
          margin-bottom: 1rem;

          .hs-field-desc {
            font-weight: 700;
            padding-bottom: 0.25rem;
            font-size: 0.75rem;
          }

          .input {
            margin-right: 0;

            input {
              width: 100% !important;
              height: 48px;
              border-radius: 5px;
              border: 1px solid ${palette.greyText};
              background-color: ${palette.solitudeFog};
              padding: 1rem;
              box-sizing: border-box;
            }
          }
        }

        @media all and (max-width: ${layout.md}) {
          grid-template-columns: 1fr;
        }
      }
    }
  }
`;

export const SubmitWrapper = styled.div`
  margin-top: 1.25rem;
`;

export const LegalText = styled.div`
  margin-top: 1rem;

  p {
    font-size: 0.625rem;
    line-height: 0.8125rem;
    font-weight: 300;
    text-align: center;
  }
`;

export const LoadingDotsWrapper = styled.div`
  padding: 2.5rem 0;
`;
